import { DoNothingState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { memo } from "react";

export const DoNothingDetails = memo(function DoNothingDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<DoNothingState>) {
  return null;
});
